import React from "react";
import { FaShareAlt } from "react-icons/fa";

const formatValue = (field, value) => {
  if (value === "" || value === undefined || value === null) return "-";
  if (field.field_type === "yes_no") return value ? "Yes" : "No";
  if (field.field_type === "duration") return `${value} minutes`;
  if (field.field_type === "select") {
    return field.options?.find((option) => String(option.value) === String(value))?.label || value;
  }
  if (field.field_type === "date") {
    return new Date(`${value}T00:00:00`).toLocaleDateString("en-GB");
  }
  if (field.field_type === "time") {
    return new Date(`2000-01-01T${value}`).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }
  return String(value);
};

const ShareModal = ({ isOpen, onShare, onNotNow, formData }) => {
  if (!isOpen) return null;
  const fields = formData.fields || [];
  const values = formData.fieldValues || {};

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-xl bg-white shadow-xl">
        <div className="p-5 sm:p-6">
          <div className="mb-4 flex items-center justify-between">
            <h2 className="text-xl font-bold text-gray-800">Entry Saved Successfully!</h2>
            <button onClick={onNotNow} className="text-gray-400 hover:text-gray-600" aria-label="Close">
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <h3 className="mb-4 text-center text-lg font-semibold text-blue-600">
            🫂 ધામભાવે અખંડ સ્મરણ વર્ષ ના જય સ્વામિનારાયણ 🫂
          </h3>
          <div className="mb-6 space-y-2 rounded-lg bg-gray-50 p-4 text-sm">
            <p className="mb-3 text-center font-semibold text-gray-700">Daily Report</p>
            <p>
              <span className="font-medium">Date:</span>{" "}
              {formData.entryDate
                ? new Date(`${formData.entryDate}T00:00:00`).toLocaleDateString("en-GB")
                : "-"}
            </p>
            {fields.map((field) => (
              <p key={field.id} className="break-words">
                <span className="font-medium">{field.label}:</span>{" "}
                {formatValue(field, values[field.field_key])}
              </p>
            ))}
          </div>

          <div className="flex gap-3">
            <button
              onClick={onShare}
              className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-green-600 px-4 py-3 font-medium text-white hover:bg-green-700"
            >
              <FaShareAlt className="text-lg" /> Share
            </button>
            <button
              onClick={onNotNow}
              className="flex-1 rounded-lg bg-gray-200 px-4 py-3 font-medium text-gray-700 hover:bg-gray-300"
            >
              Not Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
